































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import md5 from 'js-md5'
const modifyModlue = namespace('mine')
@Component
export default class ModifyMarket extends Vue {
  @modifyModlue.State('userMsg') userMsg!: any
  passwordOld: string = ''
  passwordNew: string = ''
  passwordTest: string = ''
  mounted() {}
  submitMsg() {
    if (!this.passwordOld || !this.passwordNew || !this.passwordTest) {
      ;(this as any).$notify({ type: 'warning', message: '请将密码输入完整！' })
      return
    }
    if (
      this.passwordOld.length < 6 ||
      this.passwordNew.length < 6 ||
      this.passwordTest.length < 6
    ) {
      ;(this as any).$notify({ type: 'warning', message: '密码最少六位！' })
      return
    }
    if (this.passwordNew != this.passwordTest) {
      ;(this as any).$notify({ type: 'warning', message: '两次新密码不一致！' })
      return
    }
    let params = {
      accountId: this.$global.uId,
      mobilePhone: this.$global.uPhone,
      password: md5(this.passwordNew),
      oldPassword: md5(this.passwordOld)
    }
    this.$store
      .dispatch('mine/resetPassword', params)
      .then(({ success, error }) => {
        if (success) {
          ;(this as any).$notify({ type: 'success', message: '修改成功' })
          setTimeout(() => {
            this.$router.push('/mine/easte/accountmanage')
          }, 100)
        } else {
          ;(this as any).$notify({ type: 'warning', message: error.msg })
        }
      })
  }
}
